function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#d72828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25h3v-3h-3v3zm0-19v13h3V6h-3z",
    style: {
      fill: "#e6e6e6"
    }
  }));
};

export default SvgError;